import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";

import { MedIconExpandComponent } from "./med-icon-expand.component";

@NgModule({
  declarations: [
    MedIconExpandComponent,
  ],
  imports: [
    CommonModule,
  ],
  exports: [
    MedIconExpandComponent,
  ],
})
export class MedIconExpandModule { }
